import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Autocomplete } from "@mui/material";
import { useForm } from "hooks/useForm";
import { editGasMovement } from "redux/actions/gasMovementsRequests/gasMovementsRequestActions";
import RegularButton from "components/CustomButtons/Button";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { filterMovements } from "../filterMovements";
import { isTransferMovement } from "./initialValues";
import { useTransferWarehouses } from "./useTransferWarehouses";

export const FormAddTypeMovement = ({ mov, onClose }) => {
  const dispatch = useDispatch();
  const { station } = useSelector(
    ({ gasMovementsRequests }) => gasMovementsRequests
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { movementsArr } = useSelector(({ gasMovements }) => gasMovements);
  const { stationsList } = useSelector(({ companies }) => companies);
  const initStation = mov.idStationDestino
    ? (typeof mov.idStationDestino === "object"
      ? mov.idStationDestino
      : stationsList.find((s) => s.id === mov.idStationDestino) || null)
    : null;

  const { inputValues, handleNewValues: setValues } = useForm({
    idGasMovement:
      movementsArr.find(
        (mv) => mv.movement === mov.movement || mv.label === mov.movement
      ) || null,
    comment: mov.comment || "",
    idStationDestino: initStation,
    idStorageDestino: null,
  });
  const { dateMovement, unitType } = mov;

  const isTransfer = isTransferMovement(inputValues.idGasMovement);

  const { warehouseOptions } = useTransferWarehouses({
    isTransfer,
    stationDestino: inputValues.idStationDestino,
    mov,
    setValues,
  });

  const submit = (e) => {
    e.preventDefault();
    if (!inputValues.idGasMovement) return;
    const body = {
      ...mov,
      movement: inputValues.idGasMovement.label,
      movementType: inputValues.idGasMovement.movementType,
      comment: inputValues.comment,
      edit: true,
      ...(isTransfer && {
        idStationDestino: inputValues.idStationDestino,
        idStorageDestino: inputValues.idStorageDestino,
      }),
    };
    const form = {
      id: mov.id,
      idStation: station?.id,
      idGasMovement: inputValues.idGasMovement.id,
      comment: inputValues.comment,
      ...(isTransfer && {
        idStationDestino: inputValues.idStationDestino?.id,
        idStorageDestino: inputValues.idStorageDestino?.id,
      }),
    };
    dispatch(editGasMovement(body, form, onClose));
  };

  const movementsFiltered = filterMovements(unitType, movementsArr);
  let movementsFiltered2 = [...movementsFiltered]
  if (mov?.note === null) {
    movementsFiltered2 = movementsFiltered2.filter(mo => mo.withoutNote === 1)
  }


  return (
    <form onSubmit={submit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            type="date"
            label="Fecha"
            value={dateMovement}
            variant="outlined"
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Planta"
            variant="outlined"
            fullWidth
            value={station?.label}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            id="unit-autocomplete"
            options={movementsFiltered2}
            value={inputValues.idGasMovement}
            getOptionLabel={(mov) => mov.label || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo de Movimiento"
                variant="outlined"
              />
            )}
            required={true}
            fullWidth
            onChange={(e, v) =>
              setValues({
                idGasMovement: v,
              })
            }
            disabled={isLoadingComp?.GM_newLoading}
          />
        </Grid>
        {isTransfer && (
          <>
            <Grid item xs={12}>
              <AutocompleteComponent
                name="idStationDestino"
                label="Planta Destino"
                options={stationsList}
                value={inputValues.idStationDestino}
                handleValues={(vals) => setValues({ ...vals, idStorageDestino: null })}
                sort
              />
            </Grid>
            <Grid item xs={12}>
              <AutocompleteComponent
                name="idStorageDestino"
                label="Almacén Destino"
                options={warehouseOptions}
                value={inputValues.idStorageDestino}
                handleValues={setValues}
                disabled={!inputValues.idStationDestino}
                sort
              />
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <TextField
            label="Comentario"
            variant="outlined"
            fullWidth
            value={inputValues.comment}
            onChange={(e) => setValues({ comment: e.target.value })}
            multiline
            rows={3}
            disabled={isLoadingComp?.GM_approveLoading}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          <RegularButton
            color="danger"
            onClick={onClose}
            disabled={isLoadingComp?.GM_approveLoading}
          >
            cancelar
          </RegularButton>
          <RegularButton
            color="info"
            onClick={submit}
            loading={isLoadingComp?.GM_approveLoading}
            disabled={!inputValues.idGasMovement}
          >
            Editar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  );
};
